import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { Guid } from 'Lib/Guid';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import externalTestMethods from '../../../ExternalTestMethods';

let AsFieldResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const importedFieldMoistureContentID = useSelector(
    createWorksheetSelector!('FieldResults.AssociatedFieldMoistureContent.ImportedTest.Id')
  ) as Guid;
  const importedFieldWetDensityID = useSelector(
    createWorksheetSelector!('FieldResults.AssociatedFieldWetDensity.ImportedTest.Id')
  ) as Guid;
  return (
    <>
      <WorksheetAssociatedTestSection
        heading="Field Moisture Content"
        name="FieldResults.AssociatedFieldMoistureContent"
        testType="Moisture Content"
        associatedTestModel={{
          autoImported: true,
          imported: {
            importedTestResults: (
              <ListFieldSection>
                <Field input={<TextOutput />} name="FieldResults.FieldMoistureContent" />
              </ListFieldSection>
            ),
            importModel: {
              Id: importedFieldMoistureContentID,
            },
          },
          external: {
            testMethods: [externalTestMethods.moistureContent.AS_1289_2_1_1],
            permitOtherTestMethods: false,
            externalTestResults: (
              <ListFieldSection>
                <Field
                  input={<NumericInput />}
                  name="FieldResults.AssociatedFieldMoistureContent.ExternalTest.Results.MoistureContentPercent"
                />
              </ListFieldSection>
            ),
          },
        }}
      />
      <WorksheetAssociatedTestSection
        heading="Field Wet Density"
        name="FieldResults.AssociatedFieldWetDensity"
        testType="Nuclear Field Density"
        associatedTestModel={{
          autoImported: true,
          imported: {
            importedTestResults: (
              <ListFieldSection>
                <Field input={<TextOutput />} name="FieldResults.FieldWetDensity" />
              </ListFieldSection>
            ),
            importModel: {
              Id: importedFieldWetDensityID,
            },
          },
          external: {
            testMethods: [externalTestMethods.nuclearFieldDensity.AS_1289_5_8_1],
            permitOtherTestMethods: false,
            externalTestResults: (
              <ListFieldSection>
                <Field
                  input={<NumericInput />}
                  name="FieldResults.AssociatedFieldWetDensity.ExternalTest.Results.FieldWetDensity"
                />
              </ListFieldSection>
            ),
          },
        }}
      />
      <ListFieldSection>
        <Field input={<TextOutput />} name="FieldResults.FieldDryDensity" />
      </ListFieldSection>
    </>
  );
};

AsFieldResultsSection = withInjectedProps(AsFieldResultsSection);

export { AsFieldResultsSection };
export default AsFieldResultsSection;
